// `moment-timezone` is aliased to this file by the `paths` entry in tsconfig.json,
// so every `import moment from 'moment-timezone'` in the app resolves here and gets
// the 1970-2030 data build (~20 kB gzipped) instead of the full zone database
// (~39 kB gzipped). The 1970-2030 build produces byte-identical UTC offsets to the
// full database for every zone from 1990 through 2030; only dates in 2031 and later
// diverge. Widen this to `moment-timezone-with-data` if the app ever has to render
// correct offsets past 2030.
//
// The `paths` key has no wildcard, so it matches the bare specifier only — the
// `moment-timezone/builds/...` import below resolves to the real package.
import momentWithSubsetData from 'moment-timezone/builds/moment-timezone-with-data-1970-2030';
import type momentTimezone from 'moment-timezone/index';

export type { Moment } from 'moment';

export default momentWithSubsetData as typeof momentTimezone;
